import React, { useContext, useRef } from 'react'
import LayoutContext from '../../contexts/LayoutContext'

import {
  OptionsDropDown,
  Separator,
  StyleIconDownload,
  StyleIconSend,
  StyledOverlay,
  StyledOverlayWrapper,
} from './ButtonDownloadOverlay.styled'
import { downloadDocument } from '../../utils/MenuButtonFunctions'
import { sendEmailWithDocumentLink } from '../../utils/SendEmail'
import useOnClickOutside from '../../hooks/useOnClickOutside'
import { DownloadOverlayInit } from '../../constants/DownloadOverlayInit'

export const OverlayPositonEnum = Object.freeze({
  bottom: 'bottom',
  top: 'top',
  mid: 'mid',
})

const DOWNLOAD = 'Download'
const SEND = 'Send'

const ButtonDownloadOverlay = () => {
  const { visibleDownloadOverlay, setVisibleDownloadOverlay } =
    useContext(LayoutContext)

  const ref = useRef()
  useOnClickOutside(ref, () => {
    setVisibleDownloadOverlay(DownloadOverlayInit)
  })

  return (
    <StyledOverlayWrapper
      $visibility={visibleDownloadOverlay?.visibility}
      $offsetX={visibleDownloadOverlay?.offsetX}
      $offsetY={visibleDownloadOverlay?.offsetY}
      ref={ref}
    >
      <StyledOverlay $overlayPosition={visibleDownloadOverlay?.overlayPosition}>
        <OptionsDropDown
          onClick={() => {
            visibleDownloadOverlay?.downloadGtmEvent()
            downloadDocument(visibleDownloadOverlay?.url)
            setVisibleDownloadOverlay(DownloadOverlayInit)
          }}
        >
          <StyleIconDownload />
          {DOWNLOAD}
        </OptionsDropDown>
        <Separator />
        <OptionsDropDown
          onClick={() => {
            sendEmailWithDocumentLink(visibleDownloadOverlay?.url)
            setVisibleDownloadOverlay(DownloadOverlayInit)
          }}
        >
          <StyleIconSend />
          {SEND}
        </OptionsDropDown>
      </StyledOverlay>
    </StyledOverlayWrapper>
  )
}

export default ButtonDownloadOverlay
